import { render, staticRenderFns } from "./preview_5.vue?vue&type=template&id=612c36ba&scoped=true"
import script from "./preview_5.vue?vue&type=script&lang=js"
export * from "./preview_5.vue?vue&type=script&lang=js"
import style0 from "./preview_5.vue?vue&type=style&index=0&id=612c36ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612c36ba",
  null
  
)

export default component.exports